"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drumroll = void 0;
const Note_1 = require("../Note");
const NoteType_1 = require("../lib/NoteType");
class Drumroll extends Note_1.Note {
    constructor() {
        super(NoteType_1.NoteType.Drumroll);
    }
}
exports.Drumroll = Drumroll;
